var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thick-border m-2 p-1"},[_c('h2',[_vm._v("$"+_vm._s(_vm.cost))]),_c('button',{staticClass:"btn-yellow",on:{"click":function($event){return _vm.$emit('confirm', _vm.cost)}}},[_vm._v(" Checkout ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }